import axios from "axios"

class Like {
  constructor() {
    this.bWaitUntilLastRequestEnd = false;
    if (document.querySelector(".like-box")) {
      axios.defaults.headers.common["X-WP-Nonce"] = themeJsData.nonce;
      this.events();
    }
  }

  events() {
    document.querySelector(".like-box").addEventListener("click", e => this.ourClickDispatcher(e));
  }

  // methods
  ourClickDispatcher(e) {

    if(this.bWaitUntilLastRequestEnd) {
      return;
    }

    this.bWaitUntilLastRequestEnd = true;

    let currentLikeBox = e.target;
    while (!currentLikeBox.classList.contains("like-box")) {
      currentLikeBox = currentLikeBox.parentElement;
    }

    if (currentLikeBox.getAttribute("data-exists") == "yes") {
      this.deleteLike(currentLikeBox);
    } else {
      this.createLike(currentLikeBox);
    }
  }

  async createLike(currentLikeBox) {
    try {
      const response = await axios.post(themeJsData.root_url + "/wp-json/rudra/v1/manageLike", { "tutorial_id": currentLikeBox.getAttribute("data-tutorial_id") });
      if (response.data != "Only logged in users can create a like.") {
        currentLikeBox.setAttribute("data-exists", "yes");
        var likeCount = parseInt(currentLikeBox.querySelector(".like-count").innerHTML, 10);
        likeCount++;
        currentLikeBox.querySelector(".like-count").innerHTML = likeCount;
        currentLikeBox.setAttribute("data-like", response.data);
      }
      console.log(response.data);
      this.bWaitUntilLastRequestEnd = false;
    } catch (e) {
      console.log("Sorry"); 
      this.bWaitUntilLastRequestEnd = false;
    }
  }

  async deleteLike(currentLikeBox) {
    try {
      const response = await axios({
        url: themeJsData.root_url + "/wp-json/rudra/v1/manageLike",
        method: 'delete',
        data: { "like_id": currentLikeBox.getAttribute("data-like") },
      })
      currentLikeBox.setAttribute("data-exists", "no");
      var likeCount = parseInt(currentLikeBox.querySelector(".like-count").innerHTML, 10);
      likeCount--;
      currentLikeBox.querySelector(".like-count").innerHTML = likeCount;
      currentLikeBox.setAttribute("data-like", "");
      console.log(response.data);
      this.bWaitUntilLastRequestEnd = false;
    } catch (e) {
      console.log(e);
      this.bWaitUntilLastRequestEnd = false;
    }
  }
}

export default Like




/*
// Jquery version of like.js

import $ from 'jquery';

class Like {
    constructor() {
        this.events();
    }

    events() {
        $(".like-box").on("click", this.ourClickDispacher.bind(this));
    }

    // method
    ourClickDispacher(e) {
        // whatever element is clicked on find it's closest ensister is ".like-box". in this case even if we click on heart or like number it should consider it a ".like-box".
        var currentLikeBox = $(e.target).closest(".like-box");
        if(currentLikeBox.attr('data-exists') == 'yes') {
            this.deleteLike(currentLikeBox);
        } else {
            this.createLike(currentLikeBox);
        }
    }

    createLike(currentLikeBox) {
        //console.log("createLike click");
        $.ajax({
            beforeSend: (xhr) => {
                // this is to provide extra information to query.
                // WP look for the 'X-WP-Nonce' data to authenticate the request.
                xhr.setRequestHeader('X-WP-Nonce', themeJsData.nonce);
            },
            url: themeJsData.root_url + '/wp-json/rudra/v1/manageLike',
            type:'POST',
            data: {'tutorialId': currentLikeBox.data('tutorial_id')},  
            success: (response)=> {
                currentLikeBox.attr('data-exists', 'yes');
                var likeCount = parseInt(currentLikeBox.find(".like-count").html(), 10);
                likeCount ++;
                currentLikeBox.find(".like-count").html(likeCount);

                currentLikeBox.attr('data-like', response);

                console.log("Success likeCount: " + likeCount);
                console.log(response);
            },
            error: (response)=> {
                console.log("Error");
                console.log(response);
            }
        });
    }

    deleteLike(currentLikeBox) { 
        //console.log("deleteLike click");
        $.ajax({
            beforeSend: (xhr) => {
                // this is to provide extra information to query.
                // WP look for the 'X-WP-Nonce' data to authenticate the request.
                xhr.setRequestHeader('X-WP-Nonce', themeJsData.nonce);
            },
            url: themeJsData.root_url + '/wp-json/rudra/v1/manageLike',
            data: {'like_id': currentLikeBox.attr('data-like')},  
            type:'DELETE',
            success: (response)=> {
                currentLikeBox.attr('data-exists', 'no');
                var likeCount = parseInt(currentLikeBox.find(".like-count").html(), 10);
                likeCount --;
                currentLikeBox.find(".like-count").html(likeCount);
                
                currentLikeBox.attr('data-like', '');

                console.log("Success");
                console.log(response);
            },
            error: (response)=> {
                console.log("Error");
                console.log(response);
            }
        });
    }
}

export default Like;
*/